import React from 'react';
import SkeletonComponent from './common/SkeletonComponent.jsx';

const MonitoringReportIndexSkeleton = () => {


  return (
    <>
      <div className='workflow-edit-top-bar'>
        <h1>{' '}
          <SkeletonComponent variant='text' width='100%' height='100%'>
          </SkeletonComponent>
        </h1>
      </div>
      <div style={{height: 339, margin: '15px 0'}}>
        <SkeletonComponent width='100%' height='100%'>
        </SkeletonComponent>
      </div>
      <div style={{height: 1092}}>
        <SkeletonComponent width='100%' height='100%'>
        </SkeletonComponent>
      </div>
    </>
  )
}

export default MonitoringReportIndexSkeleton;